import { backgroundColoredColors, iconColors } from '../tokens/color';

export const enecoExpandableTokens = {
  expandableIndicatorBackground: backgroundColoredColors.backgroundVarThree,
  expandableDefaultIndicatorColor: iconColors.iconOnBackgroundVarThree,
  expandableTransparentIndicatorColor: iconColors.iconSecondary,
};
